import React from "react";
import OwlCarousel from 'react-owl-carousel2';
import 'react-owl-carousel2/src/owl.carousel.css';
import 'react-owl-carousel2/src/owl.theme.default.css';
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import FeatureSlide from "./featureSlide";
import * as styles from './featureSlider.module.css';

let image1 = require('../images/hfeatures-1.png').default;
let image2 = require('../images/hfeatures-2.png').default;
let image3 = require('../images/hfeatures-3.png').default;

let owlClass = "listing-owl listing-owl--fs " + styles.listingWrap;

const options = {
    items: 3,
    nav: false,
    dots: false,
    rewind: false,
    autoplay: false,
    freeDrag : false,
    margin: 10,
    responsive : {
        0 : {
            items: 1,
            stagePadding: 50
        },
        900 : {
            items: 3,
            mouseDrag: false,
            pullDrag: false,
            stagePadding: 0
        }
    }
};


function FeatureSlider(props) {

    
    let bgcolor = (props.bgcolor) ? props.bgcolor.hex : '#FFFFFF';
    let bgcolorbot = (props.bgcolorbot) ? props.bgcolorbot.hex : '#FFFFFF';

    return (
        <div className={styles.sectionFeatureSlider} style={{ backgroundColor: `${bgcolor}`}}>
            <div className={styles.sectionContent}>
                <div className={styles.sectionContainer}>
                    <h3>{props.heading}</h3>
                    
                    <div className={owlClass}>
                    
                        <OwlCarousel options={options}>

                            {
                                props.items.map((item, i) => {  
                                    return <FeatureSlide item={item} key={i} />
                                })
                            }

                        </OwlCarousel>

                    </div>

                </div>
            </div>
            <div className={styles.sectionBottomBackground} style={{ backgroundColor: `${bgcolorbot}`}}></div>
        </div>
    );
}
  
export default FeatureSlider;